// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__ODlA-","loaderOuter":"PageOverlayLoader_loaderOuter__1qtec"};